'use strict';

import raven from 'raven';
import angular from 'angular';
import FormController from 'app/controllers/form';

class OperativeSpendingController extends FormController {
    /* @ngInject */
    constructor(
        OperativeSpendingsService,
        EmployeesService,
        QuotesService,
        VehiclesService,
        ClientsService,
        VouchersService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location,
        $filter,
        $stateParams
    ) {
        let spending = $scope.$parent.$resolve.spending;
        super(
            spending,
            'Gasto Operativo',
            OperativeSpendingsService,
            null,
            'operative-spendings'
        );
        this.user = $scope.$parent.$resolve.user;
        this.voucherId = $stateParams.voucherId || this.model.voucherId;

        Object.assign(this, {
            OperativeSpendingsService,
            EmployeesService,
            QuotesService,
            VehiclesService,
            ClientsService,
            VouchersService,
            $mdDialog,
            $mdToast,
            $state,
            $location,
            $filter
        });
        this.btnEnabled = true;

        if (this.model.id) {
            this.neverEditable = true;
            this.employee = this.model.employee;
            this.vehicle = this.model.vehicle;
            this.holder = this.model.holder;
            this.quote = this.model.quote;
            this.availableQuotes = [this.quote];
            this.availableVouchers = [this.model.voucher];

            this.osItems = this.model.osItems.reduce((osItem, x) => {
                (
                    osItem[x['item']['procedure']['id']]
                        = osItem[x['item']['procedure']['id']] || []
                ).push(x);
                return osItem;
            }, {});
            this.procedures = this.model.osItems
                .map(osItem => osItem.item.procedure)
                .filter(
                    (osItem, index, a) => a.findIndex(
                        v => v.id == osItem.id
                    ) === index
                );
        } else {
            if ($stateParams.quoteId) {
                // quote passed as param
                this.quoteId = $stateParams.quoteId;
                this.model.quoteId = $stateParams.quoteId;
                this.vehicle = this.model.vehicle = $scope.$parent.$resolve.quote.vehicle;
                this.holder = this.model.holder = $scope.$parent.$resolve.quote.holder;
                this.quote = this.model.quote = $scope.$parent.$resolve.quote;
            }
            Object.assign(this.model, {
                amount: 0,
                voucherId: this.voucherId,
                positiveAmount0: 0,
                positiveAmount1: 0,
                positiveAmount2: 0,
                negativeAmount0: 0,
                negativeAmount1: 0
            });

            if (this.user.isAdmin) {
                // is admin
                this.canChangeEmployee = this.voucherId ? false : true;
            } else if (this.user.employee) {
                // non admin: fixed employee
                this.employee = this.user.employee;
                this.model.employee = this.user.employee;
            }
        }
    }

    save(ev) {
        if (!this.form.$valid) {
            console.debug(this.form);
            return;
        }

        Promise.resolve().then(() => {
            if (!this.quote) {
                var confirm = this.$mdDialog.confirm()
                    .title('Falta Orden de Trabajo')
                    .textContent(`No fue seleccionada una OT para este gasto,
desea continuar y guardarlo de todas maneras?`)
                    .ariaLabel('Lucky day')
                    .targetEvent(ev)
                    .ok('Si, guardar')
                    .cancel('Cancelar');

                return this.$mdDialog.show(confirm);
            }
        }).then(() => {
            return super.save();
        }, err => {
            //
        }).then(() => {
            if (this.voucherId) {
                this.$state.go('voucherCollection', {
                    id: this.voucherId
                });
            }
        });
    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    afterSave() {
        this.$state.go('editOperativeSpending', {
            id: this.model.id
        });
    }

    $onInit() {
        super.$onInit();

        this.canBeAssociated = !this.model.associatedAt
            && this.model.quoteId
            && (this.model.employee ?
                this.model.collection
                && this.model.collection.state == 'approved' : true
               );
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }

    selectedEmployeeChange(employee) {
        if (employee) {
            this.model.employee = employee;
            this.employee = employee;
        }
    }

    void(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Gasto')
            .textContent('Ingrese el motivo')
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent(ev)
            .ok('Anular el gasto')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.OperativeSpendingsService.void({
                id: this.model.id,
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                this.model.deletionReason = result;
                this.model.deletedAt = new Date();
            });
        });
    }

    queryHolderSearch() {
        return this.ClientsService.find({
            filter: {
                where: {
                    or: [
                        {
                            name: {
                                ilike: `%${this.searchHolderText}%`
                            }
                        },
                        {
                            lastName: {
                                ilike: `%${this.searchHolderText}%`
                            }
                        }
                    ]
                }
            }
        });
    }

    selectedHolderChange(client) {
        if (client) {
            this.model.holder = client;
            this.holder = client;
        }
    }

    queryVehicleSearch() {
        return this.VehiclesService.getModels({
            where: {
                broad: this.searchVehicleText
            },
            order: 'plate DESC, number DESC, description DESC'
        }).then(vehicles => {
            return vehicles.map(v => {
                v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
                return v;
            });
        });
    }

    selectedVehicleChange(vehicle) {
        if (vehicle) {
            this.model.vehicle = vehicle;
            this.vehicle = vehicle;
        }
    }

    getClientName(client) {
        if (client)
            return client.lastName + ' ' + client.name;
    }

    loadQuotes() {
        console.debug(this.vehicle, this.holder);
        if (!this.vehicle && !this.holder) {
            return Promise.resolve([]);
        }
        let where = {};
        if (this.vehicle) {
            where.vehicleId = this.vehicle.id;
        }
        if (this.holder) {
            where.holderId = this.holder.id;
        }
        return this.QuotesService.find({
            filter: {
                where: where,
                include: ['client', 'vehicle', 'holder', 'procedures'],
                order: 'approvedAt ASC'
            }
        });
    }

    getQuoteItemTitle(quote) {
        if (!quote) {
            return '';
        }
        let date = this.$filter('formatDate')(quote.createdAt);
        let holder = quote.holder.lastName + ' ' + quote.holder.name;
        let vehicle = quote.vehicle.plate
            || quote.vehicle.number
            || quote.vehicle.description
            || 'Sin patente';
        let text = `Id: #${quote.id} - Fecha: ${date} - Titular: ${holder} \
- Vehiculo: ${vehicle}`;
        return text;
    }

    getQuoteItemMetadata(quote) {
        
        let procedure = quote.procedures.length ?
            quote.procedures[0].description : 'S/D';
        let total = `${this.$filter('formatMoney')(quote.totalFinalAmount)}`;
        let totalReceipts = `${this.$filter('formatMoney')(quote.totalAmount)}`;

        return `<span class="mr1">Tramite: <strong>${procedure}</strong></span>`
            + `<span class="mr1">Total: <strong>${total}</strong></span>`
            + `<span class="mr1">Total cobrado: \
<strong>${totalReceipts}</strong></span>`;
    }

    onQuoteChange(quote) {
        if (quote) {
            this.quote = quote;
            this.model.quote = quote;

            this.vehicle = quote.vehicle;
            this.model.vehicle = quote.vehicle;

            this.holder = quote.holder;
            this.model.holder = quote.holder;
        }
    }

    getVehicleLabel(v) {
        let fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return fullDesc;
    }

    disassociate() {
        this.showDisassociateSpin = true;
        this.OperativeSpendingsService.disassociate({
            id: this.model.id
        }).then(() => {
            this.model.associatedAt = null;
            this.showDisassociateSpin = false;
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    loadVouchers() {
        return this.VouchersService.find({
            filter: {
                where: {
                    deletedAt: null,
                    remainingAmount: {
                        gt: 0
                    }
                },
                include: [],
                order: 'createdAt ASC'
            }
        }).then(vouchers => {
            this.availableVouchers = vouchers;
        });
    }

    getVoucherLabel(voucher) {
        if (!voucher) return '';
        let date = this.$filter('formatDate')(voucher.createdAt);
        let amount = this.$filter('formatMoney')(voucher.amount);
        let remaining = this.$filter('formatMoney')(voucher.remainingAmount);
        let text = `#${voucher.id} - ${date} - ${amount} - ${remaining}`;
        return text;
    }

    associate() {
        this.$state.go('editQuote', {
            id: this.model.quoteId,
            operativeSpendingId: this.model.id
        });
    }

    updateAmounts() {
        this.model.amount =
            this.model.positiveAmount0
            + this.model.positiveAmount1
            + this.model.positiveAmount2
            - this.model.negativeAmount0
            - this.model.negativeAmount1;
    }
}

export default OperativeSpendingController;
